module.exports = __webpack_public_path__ + "img/brand15.fda45179.png";